import { defineFcm } from '../shared/factory';

export const FCM_USE_DONATION_LANGUAGE = defineFcm('use_donation_language')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform-payments',
		scope: ['comms-stack', 'corgi-front-end', 'promotion-service'],
		context: 'Payment forms',
		description: 'Whether or not to use copy that refers to transactions as donations',
	});
